import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { AccountAdminPresentation } from './account-admin-presentation';
import { AccountAdminContext, connectAccountAdminVM } from './account-admin.context';
import { AccountAdminVM } from './account-admin.viewmodel';

interface IProps {
    vm: AccountAdminVM;
}

const AccountAdminContainer = ({ vm }: IProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <AccountAdminPresentation vm={vm} />;
};

const AccountAdminConnected = connectAccountAdminVM<IProps>(AccountAdminContainer, vm => ({ vm: vm }));

export const AccountAdmin = moduleHost(AccountAdminVM, AccountAdminContext, AccountAdminConnected);
